<template>
  <div class="bordered-group vs-card vs-con-block mt-5">
    <div class="vs-card-content">
      <div class="vx-row ">
        <div class="vx-col w-full">
          <vs-table max-items="10" :data="payments">
            <template slot="header">
              <div class="vx-row  w-full mb-1 mr-0 ml-0 p-0">
                <div class="vx-col w-1/3">
                  <h6>ข้อมูลการชำระเงิน</h6>
                </div>
                <div class="vx-col w-2/3 flex justify-end m-0 p-0">
                  <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-chevrons-right"  class="mr-1" @click="onPressedCalculate()" v-if="visibilityCalculateButton">ประมวณผล</vs-button>
                  <AdminPaymentQr />
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus"  @click="onPressedActiveAddPayment()">เพิ่มข้อมูล</vs-button>
                </div>
              </div>
            </template>

            <template slot="thead">
              <vs-th >#</vs-th>
              <vs-th >วันที่ชำระ</vs-th>
              <vs-th >ประเภทการชำระ</vs-th>
              <vs-th >จำนวน</vs-th>
              <vs-th >ค่าธรรมเนียม</vs-th>
              <vs-th >เบี้ยปรับ</vs-th>
              <vs-th >ดอกเบี้ย</vs-th>
              <vs-th >เงินต้น (ดอกเบี้ยล่วงหน้า)</vs-th>
              <vs-th class="col-createdBy">ผู้บันทึก</vs-th>
              <vs-th class="col-approved">สถานะประมวลผล</vs-th>
              <vs-th class="col-actions"></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                <vs-td>{{ data.length - index }}</vs-td>
                <vs-td>{{ row.paymentDateLocalTh }}</vs-td>
                <vs-td>
                  {{ row.paymentTypeName }}
                </vs-td>
                <vs-td class="text-right">{{ row.paymentAmount | numberFormat }}</vs-td>
                <vs-td class="text-right">{{ row.paymentAmountDetail !== null ? $options.filters.numberFormat(row.paymentAmountDetail.paidFee) : '-' }}</vs-td>
                <vs-td class="text-right">{{ row.paymentAmountDetail !== null ? $options.filters.numberFormat(row.paymentAmountDetail.paidPenalty) : '-' }}</vs-td>
                <vs-td class="text-right">{{ row.paymentAmountDetail !== null ? $options.filters.numberFormat(row.paymentAmountDetail.paidInterest) : '-' }}</vs-td>
                <vs-td class="text-right">{{ row.paymentAmountDetail !== null ? $options.filters.numberFormat(row.paymentAmountDetail.paidPrinciple) : '-' }}({{ row.paymentAmountDetail !== null ? $options.filters.numberFormat(row.paymentAmountDetail.balanceRemain) : '-' }})</vs-td>
                <vs-td>{{ row.createByFullName }}<br>{{ row.createdAtLocalTh }}</vs-td>
                <vs-td>
                  <vs-chip :color="row.processed ? 'success' : 'warning'">{{ row.processed ? 'ประมวลผลแล้ว' : 'รอประมวลผล' }}</vs-chip>
                </vs-td>
                <vs-td>
                  <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end" v-if="!row.processed || (row.paymentType === IPaymentType.qrCode && isRoot)">
                    <vx-tooltip text="แก้ไขข้อมูลการชำระเงิน">
                      <vs-button  class="mr-1" color="warning" type="filled" icon-pack="feather" icon="icon-edit" @click="onPressedActiveUpdatePayment(row)" v-if="!row.processed && row.paymentType === IPaymentType.operator"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="ลบข้อมูลการชำระเงิน">
                      <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="onPressedDelPayment(row.id)" v-if="(!row.processed && row.paymentType === IPaymentType.operator) || (row.paymentType === IPaymentType.qrCode && isRoot)"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>

    </div>

    <vs-popup :active="!!paymentDeleteMessage" title="ไม่สามารถลบรายการได้" :button-close-hidden="true">
      <p style="user-select: text; line-height: 1.8">{{ paymentDeleteMessage }}</p>
      <vs-button @click="paymentDeleteMessage = ''">ตกลง</vs-button>
    </vs-popup>
    <vs-popup
      :active.sync="paymentModal.active"
      :title="paymentModal.title"
      class="custom-popup"
    >
      <div class="popup-content">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent="handleSubmit">
          <div class="vx-row">
            <div class="vx-col w-1/3">
              <ValidationProvider name="วันที่" rules="required" v-slot="{ errors }" >
                <label class="text-sm">วันที่*</label>
                <flat-pickr :config="configDatePayment" class="w-full" v-model="paymentModal.date"/>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/3">
              <ValidationProvider name="จำนวน" :rules="{ required: true, min_value: 0.01 }" v-slot="{ errors }" >
                <label class="text-sm">จำนวน*</label>
                <vs-input type="number" class="w-full" v-model="paymentModal.amount"/>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/6">
              <ValidationProvider name="ชำระเงินต้น" rules="" v-slot="{ errors }" >
                <label class="text-sm">ชำระเงินต้น</label>
                <vs-checkbox v-model="paymentModal.paymentPrinciple"></vs-checkbox>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/6">
              <ValidationProvider name="ปรับยอด" rules="" v-slot="{ errors }" >
                <label class="text-sm">ปรับยอด</label>
                <vs-checkbox v-model="paymentModal.adjustment"></vs-checkbox>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <validation-provider name="หมายเหตุ" rules="" v-slot="{ errors }">
                <label class="vs-input--label">หมายเหตุ*</label>
                <vs-textarea  v-model="paymentModal.paymentRemark" rows="5"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          </form>
        </ValidationObserver>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptAddPayment">บันทึก</vs-button>
        <vs-button color="danger" @click="paymentModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>

  </div>
</template>

<script>
import AdminPaymentQr from "../AdminPaymentQr.vue";
import Divider from "@/views/components/vuesax/divider/Divider.vue";
import {createNamespacedHelpers} from "vuex";
import {visibility} from "tailwindcss/lib/plugins";
import moment from "moment";
import { Thai } from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import flatPickr from "vue-flatpickr-component";
import {IPaymentType} from "@/constants/interface";
import {isRoot as fncIsRoot} from "@/utils";

const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers('Accounting');

export default {
  name: 'PaymentInfoTab',
  components: {
    AdminPaymentQr,
    Divider,
    flatPickr
  },
  data() {
    return {
      paymentDeleteMessage: '',
      clearTransactionsPopup: {
        active: false,
        date: moment().format('DD-MM-YYYY'),
      },
      paymentModal: {
        active: false,
        type: 'add',
        title: 'เพิ่มข้อมูลการชำระเงิน',
        id: null,
        date: moment().format('DD-MM-YYYY'),
        amount: 0,
        paymentPrinciple: false,
        adjustment: false,
        paymentRemark: "",
      },
    };
  },
  computed: {
    ...mapAccountingFields(['contractDetail','contractDetailPayments']),
    IPaymentType() {
      return IPaymentType
    },
    isRoot () {
      return fncIsRoot();
    },
    configDateClearTransactions(){
      const vm = this
      let minDate = null
      let maxDate = null

      if(vm.contractDetail != null) {
        const { contractLoanDate } = vm.contractDetail
        if(contractLoanDate){
          minDate = moment(contractLoanDate).add(1, 'days').format('DD-MM-YYYY')
        }
      }

      return {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
        minDate,
        maxDate
      }
    },
    configDatePayment(){
      const vm = this
      let minDate = null
      let maxDate = null
      let lastUpdateDate = null

      if(vm.contractDetail) {
        const { loan } = vm.contractDetail
        if(loan){
          const { lastUpdate } = loan
          lastUpdateDate = moment(lastUpdate).add(1, 'days')
          minDate = lastUpdateDate.format('DD-MM-YYYY')
        }
      }

      return {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
        minDate,
        maxDate
      }
    },
    visibilityCalculateButton() {
      if (!this.contractDetailPayments) return false;
      const unProcessPayments = this.contractDetailPayments.filter(({processed}) => !processed);
      return unProcessPayments.length > 0;
    },
    payments() {
      if (!this.contractDetailPayments) return null;
      return [...this.contractDetailPayments]
        .sort(({ paymentDate: aPaymentDate, createdAt: aCreatedAt }, { paymentDate: bPaymentDate, createdAt: bCreatedAt }) => {
          const paymentDateDiff = new Date(bPaymentDate) - new Date(aPaymentDate);
          if (paymentDateDiff !== 0) {
            return paymentDateDiff;
          }
          return new Date(bCreatedAt) - new Date(aCreatedAt);
        })
        .map((payment) => {
          const {
              id,
              adjustment,
              paymentType,
              paymentDate,
              paymentAmount,
              paymentPrinciple,
              paymentRemark,
              paymentTypeName,
              createdAtLocalTh,
              createByFullName,
              paymentDateLocalTh,
              processed,
              paymentAmountDetail
          } = payment;
          return {
            id,
            adjustment,
            paymentType,
            paymentDate,
            paymentAmount,
            paymentPrinciple,
            paymentRemark,
            paymentTypeName,
            createdAtLocalTh,
            createByFullName,
            paymentDateLocalTh,
            processed,
            paymentAmountDetail,
          }
        })
    },
  },
  methods: {
    ...mapAccountingActions(['getContractDetail', 'calculateContractDetailPayment', 'createContractDetailPayment', 'updateContractDetailPayment', 'deleteContractDetailPayment', 'createQrPayment']),
    visibility() {
      return visibility
    },
    async onPressedCalculate() {
      const { id: contractId } = this.$route.params;
      const { calculateContractDetailPayment } = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'ยืนยันการประมวลผล',
        text: 'คุณต้องการประมวลผลข้อมูลการชำระเงินใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await calculateContractDetailPayment({
            contractId,
          })
        }
      })
    },
    async onPressedActiveAddPayment() {
      const vm = this
      vm.paymentModal.active = true
      vm.paymentModal.type = 'add'
      vm.paymentModal.id = null
      vm.paymentModal.title = 'เพิ่มข้อมูลการชำระเงิน'
      vm.paymentModal.date = moment().format('DD-MM-YYYY');
      vm.paymentModal.amount = 0
      vm.paymentModal.paymentPrinciple = false
      vm.paymentModal.adjustment = false
      vm.paymentModal.paymentRemark = ""
    },
    async onPressedActiveUpdatePayment(row) {
      const vm = this
      vm.paymentModal.active = true
      vm.paymentModal.type = 'update'
      vm.paymentModal.id = row.id
      vm.paymentModal.title = 'แก้ไขข้อมูลการชำระเงิน'
      vm.paymentModal.date = moment(row.paymentDate).format('DD-MM-YYYY');
      vm.paymentModal.amount = row.paymentAmount
      vm.paymentModal.paymentPrinciple = row.paymentPrinciple
      vm.paymentModal.adjustment = row.adjustment
      vm.paymentModal.paymentRemark = row.paymentRemark
    },
    async onPressedAcceptAddPayment() {
      const vm = this
      const contractId  = this.$route.params.id;
      const {createContractDetailPayment, updateContractDetailPayment} = vm;
      vm.$refs['form'].validate().then(async success => {
        if (!success) {
          return
        }
        // console.log("vm.paymentModal.type:", vm.paymentModal.type)
        const receiveDate = vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.paymentModal.date.trim())
        const paymentDate = vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.paymentModal.date.trim())
        if(vm.paymentModal.type === 'add') {
          await createContractDetailPayment ({
            contractId,
            form: {
              receiveDate: receiveDate,
              paymentDate: paymentDate,
              paymentAmount: parseFloat(vm.paymentModal.amount),
              paymentPrinciple: vm.paymentModal.paymentPrinciple,
              adjustment: vm.paymentModal.adjustment,
              paymentRemark:  vm.paymentModal.paymentRemark,
            }
          });
        }else if(vm.paymentModal.type === 'update') {
          await updateContractDetailPayment({
            id: vm.paymentModal.id,
            form: {
              receiveDate: receiveDate,
              paymentDate: paymentDate,
              paymentAmount: parseFloat(vm.paymentModal.amount),
              paymentPrinciple: vm.paymentModal.paymentPrinciple,
              adjustment: vm.paymentModal.adjustment,
              paymentRemark:  vm.paymentModal.paymentRemark,
            }
          })
        }
        vm.paymentModal.active = false;
      })
    },
    async onPressedDelPayment(id) {
      const vm = this
      const { deleteContractDetailPayment } = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการลบข้อมูล',
        text: 'คุณต้องการลบข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          const result = await deleteContractDetailPayment({
            id,
            vm
          })
          if (result && result.blockedMessage) vm.paymentDeleteMessage = result.blockedMessage
        }
      })
    },
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}

.col-createdBy {
  width: 200px;
}

.col-approved {
  width: 130px;
}

.col-actions {
  width: 100px;
}

.custom-popup .vs-popup {
  width: 600px;
}
.popup-content {
  padding: 10px;
}
.payment-amount-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 16px;
}
.payment-amount-options button {
  padding: 12px;
  border: 1px solid #d5dce3;
  border-radius: 6px;
  background: white;
  color: #174e78;
  cursor: pointer;
}
.payment-amount-options button.selected { background: #eaf3fa; border-color: #174e78; }
.payment-amount-options button:disabled { opacity: .5; cursor: default; }
@media (max-width: 480px) {
  .payment-amount-options { grid-template-columns: 1fr; }
}
.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}
.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}


.contract-qr-popup >>> .vs-popup {
  width: 400px;
  max-width: calc(100vw - 32px);
}


</style>
